// Add these to the existing src/utils/formatters.ts file

import {format, isValid, parseISO} from "date-fns";

/**
 * Check if an account expiration date has passed
 */
export const isExpired = (expirationDate: string | null | undefined): boolean => {
    if (!expirationDate) return false;
    try {
        return new Date(expirationDate) < new Date();
    } catch {
        return false;
    }
};

/**
 * Get days until expiration
 */
export const getDaysUntilExpiration = (expirationDate: string | null | undefined): number | null => {
    if (!expirationDate) return null;
    try {
        const expDate = new Date(expirationDate);
        const today = new Date();
        const diffTime = expDate.getTime() - today.getTime();
        return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    } catch {
        return null;
    }
};

/**
 * Check if expiration is within warning period (30 days)
 */
export const isExpiringSoon = (expirationDate: string | null | undefined, warningDays: number = 30): boolean => {
    const daysUntil = getDaysUntilExpiration(expirationDate);
    return daysUntil !== null && daysUntil <= warningDays && daysUntil > 0;
};

/**
 * Format a date string or Date object for display
 */
export const formatDate = (
    date: string | Date | null | undefined,
    formatString = 'MMM dd, yyyy'
): string => {
    if (!date) return '';

    const dateObj = typeof date === 'string' ? parseISO(date) : date;

    if (!isValid(dateObj)) return '';

    return format(dateObj, formatString);
};
